/*
NOTE: this file only temporarily resides in scratch-gui.
Nearly identical code appears in scratch-www, and the two should
eventually be consolidated.
*/

import {injectIntl} from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import AccountNavComponent from '../components/menu-bar/account-nav.jsx';
import {
    getUserAvatarUrl,
    getUserDisplayName,
    userHasRole
} from '../lib/user-session';

const AccountNav = function (props) {
    const {
        ...componentProps
    } = props;
    return (
        <AccountNavComponent
            {...componentProps}
        />
    );
};

AccountNav.propTypes = {
    classroomId: PropTypes.string,
    isAdmin: PropTypes.bool,
    isEducator: PropTypes.bool,
    isRtl: PropTypes.bool,
    isStudent: PropTypes.bool,
    onLogOut: PropTypes.func,
    onOpenMaterials: PropTypes.func,
    onOpenProfile: PropTypes.func,
    onOpenProjects: PropTypes.func,
    thumbnailUrl: PropTypes.string,
    username: PropTypes.string
};

const mapStateToProps = state => {
    const userSession = state.scratchGui.userSession || {};
    const user = userSession.user || {};
    const isAuthenticated = userSession.isAuthenticated
    return {
        classroomId: '',
        isAdmin: isAuthenticated && userHasRole(user, 'Admin'),
        isEducator: isAuthenticated && userHasRole(user, 'Educator'),
        isStudent: isAuthenticated && userHasRole(user, 'Student'),
        thumbnailUrl: getUserAvatarUrl(user),
        username: getUserDisplayName(user)
    };
};

const mapDispatchToProps = () => ({});

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(AccountNav));
